import Reminder20 from '@carbon/icons-react/es/reminder/20';
import moment, { ISO_8601 } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskDueDateReminder } from 'api/notifications/meta';
import { RelativeTime } from 'components/atoms/relative-time';
import { Strong, useNotificationMessage } from '../basics';

export const TaskDueDateReminderView: FC<{
  timestamp: string;
  meta: TaskDueDateReminder;
  isTaskWithFormInstance: boolean;
}> = ({ timestamp, meta: { at }, isTaskWithFormInstance }) => (
  <FormattedMessage
    id={
      isTaskWithFormInstance
        ? 'notifications.messages.form_task_due_date_reminder'
        : 'notifications.messages.task_due_date_reminder'
    }
    values={{
      reminder: (
        <>
          <Reminder20 />
          <Strong>{useNotificationMessage('reminder')}</Strong>
        </>
      ),
      duration: (
        <RelativeTime
          time={moment(at, ISO_8601)}
          from={moment(timestamp, ISO_8601)}
        />
      ),
    }}
  />
);
